/* global ga */
import Player from '../objects/player';
import Navigator from '../objects/items/navigator';
import Handwheel from '../objects/items/handwheel';
import LogicGroup from './logic_group';
import Ship from '../objects/ship';
import Furnace from '../objects/furnace';
import Shield from '../objects/items/shield';
import GunTerminal from '../objects/items/gun_terminal';
import MedBed from '../objects/items/medbed';
import Hammer from '../objects/items/hammer';
import GameState from './game_state';
import GameStateUI from './ui/game_state_ui';
import Narrator from './events/narrator';
import Room from '../objects/room';
import Door from '../objects/door';
import Musician from './musician';
import { MovementGraph } from './mover';
import BrownAlien from '../objects/items/moveable/brown_alien';
import GreenAlien from '../objects/items/moveable/green_alien';
import RoboAlien from '../objects/items/moveable/robo_alien';
import FriendlyAlien from '../objects/items/moveable/friendly_alien';
import Stars from './stars';

import Jenkins from '../objects/items/moveable/jenkins';
import * as ItemFactory from '../objects/items/items_factory';
import Sounder from './sounder';

export default {

    create() {
        game.world.alpha = 1;
        game.physics.startSystem(Phaser.Physics.ARCADE);

        this.cursors = game.input.keyboard.createCursorKeys();
        this.keys = {
            space: game.input.keyboard.addKey(Phaser.Keyboard.SPACEBAR),
            f: game.input.keyboard.addKey(Phaser.Keyboard.F),
            esc: game.input.keyboard.addKey(Phaser.Keyboard.ESC),
            tab: game.input.keyboard.addKey(Phaser.Keyboard.TAB),
            enter: game.input.keyboard.addKey(Phaser.Keyboard.ENTER)
        };

        this.wasd = {
            up: game.input.keyboard.addKey(Phaser.Keyboard.W),
            down: game.input.keyboard.addKey(Phaser.Keyboard.S),
            left: game.input.keyboard.addKey(Phaser.Keyboard.A),
            right: game.input.keyboard.addKey(Phaser.Keyboard.D)
        };

        this.backgroundGroup = game.add.group();
        this.activeGroup = game.add.group();
        this.objects = new LogicGroup(this.activeGroup);
        this.units = new LogicGroup(this.activeGroup);
        this.effectsGroup = game.add.group();
        this.doors = new LogicGroup(this.activeGroup);
        this.overlayGroup = game.add.group();
        this.uiGroup = game.add.group();
        game.effectsGrp = this.effectsGroup;

        this.gameState = new GameState(this.objects);
        this.graph = new MovementGraph();
        game.graph = this.graph;

        this.loadBackground();
        this.loadTilemap();
        this.setupItems();
        this.loadWaypoints();
        this.gameState.hero = this.hero;
        this.gameState.furnace = this.furnace;
        this.gameStateUI = new GameStateUI(this.gameState, this.uiGroup);

        this.narrator = new Narrator(this.gameState, this.uiGroup);
        game.narrator = this.narrator;
        if (game.musician) {
            game.musician.stop();
        }
        this.musician = new Musician();

        this.musician.playIdle();
        game.musician = this.musician;

        //this.objects.add(new BrownAlien(this.hero.centerX + 10, this.hero.centerY + 30));
        //this.objects.add(new FriendlyAlien(this.hero.centerX - 10, this.hero.centerY + 30));
        //this.objects.add(new Jenkins(this.hero.centerX - 10, this.hero.centerY + 30));
        //this.objects.add(new RoboAlien(this.hero.centerX + 10, this.hero.centerY + 30));
        game.gameState = this.gameState;
        this.sounder = game.sounder = new Sounder();
    },

    ///////////// Setup part ////////////////


    loadWaypoints() {
        for (let waypoint of this.map.objects.waypoints) {
            let n1 = {
                x: waypoint.x,
                y: waypoint.y
            };
            let n2 = {
                x: waypoint.x + waypoint.polyline[1][0],
                y: waypoint.y + waypoint.polyline[1][1]
            };
            this.graph.addEdge(n1, n2);
        }
        this.graph.tilemap = this.map;
        this.graph.bgLayer = this.bgLayer;
    },

    loadBackground() {
        this.ship = new Ship(0, 0, this.backgroundGroup);
        this.ship.showInGameShip();
        this.ship.centerCamera();
        this.stars = new Stars(game.camera.x, game.camera.y, this.gameState, this.backgroundGroup);
        this.stars.moveBack();
        game.shipBounds = this.ship.getBounds();

    },

    setupItems() {
        for (let o of this.map.objects.items) {
            let dice = game.rnd.frac();
            let type = o.name;
            let prop = o.properties && o.properties.prop ? o.properties.prop : 1;
            if (dice <= prop) {
                this.objects.add(ItemFactory.produceInitialAtLT(o.x, o.y, type));
            }
        }
    },


    addPlayer(x, y) {
        this.units.add(this.hero = new Player(x, y));
    },

    loadTilemap() {
        let map = game.add.tilemap('ship1');
        map.addTilesetImage('pre', 'pre', 3, 3);
        map.setCollisionByExclusion([]);
        let layer = map.createLayer('walls');
        layer.resizeWorld();
        this.bgLayer = layer;
        this.backgroundGroup.add(layer);
        let doors = [];
        let appendixes = [];
        for (let o of map.objects.zones) {
            switch (o.name) {
                case 'hero':
                    this.addPlayer(o.x, o.y);
                    break;
                case 'furnace':
                    this.furnace = new Furnace(o.x, o.y);
                    this.backgroundGroup.add(this.furnace);
                    break;
                case 'room':
                    this.gameState.rooms.push(new Room(o, this.backgroundGroup, this.overlayGroup));
                    break;
                case 'room-appendix':
                    appendixes.push(o);
                    break;
                case 'door':
                    doors.push(new Door(o.x, o.y, o.height > o.width, o.properties["room-ids"].split(',')));
                    break;
                default:
                    //console.log(o.name, o.properties, o.x, o.y);
            }
        }
        for (let d of doors) {
            this.doors.add(d);
            for (let r of this.gameState.rooms.filter(r => d.ids.indexOf(r.id) !== -1)) {
                r.doors.push(d);
                d.rooms.push(r);
            }
        }
        for (let a of appendixes) {
            let room = this.gameState.rooms.find(r => r.id === a.properties.id);
            if (!room) console.warn("cannot find room with id", a.properties.id);
            room.addAppendix(a);
        }
        this.map = map;
    },

    ///////////// Update (logic) part ////////////////

    update() {
        this.stars.update();
        this.gameState.update();
        this.gameStateUI.update();
        this.narrator.update();
        this.narrator.ui.update(this.cursors, this.keys);
        if (!game.gameState.canUpdateItem()) {
            this.hero.stop();
            return;
        }
        for (let room of this.gameState.rooms) {
            room.update();
        }

        game.physics.arcade.collide(this.hero, this.bgLayer);
        game.physics.arcade.collide(this.hero, this.furnace);
        this.objects.forEachStanding(o => {
            game.physics.arcade.collide(this.hero, o);
        });
        this.doors.forEach(door => {
            game.physics.arcade.collide(this.hero, door);
        });

        this.objects.forEachWalking(walking => {
            this.doors.forEach(door => {
                game.physics.arcade.collide(walking, door);
            });

            if (walking.isMadJenkins && walking.madness === 'repaint' && !walking.mover.isMoving && walking.painted < 10) {
                let tiles = this.bgLayer.getTiles(walking.x - 20, walking.y - 20, 40, 40, true).filter(t => t.index < 3);
                if (tiles.length) {
                    let toRepaint = game.rnd.pick(tiles);
                    this.map.replace(1, game.rnd.pick([5, 6, 7]), toRepaint.x, toRepaint.y, 1, 1);
                    walking.painted++;
                }
            }

            this.objects.forEach(o => {
                if (o === walking) return;
                if (o.walking) {
                    if (walking.onCollideWithWalking) {
                        game.physics.arcade.collide(walking, o, undefined, () => {
                            //on collide with standing
                            return walking.onCollideWithWalking(o);
                        });

                    }
                    if (walking.checkDistanceWalking) walking.checkDistanceWalking(o);
                } if (o.standing) {
                    game.physics.arcade.collide(walking, o, () => {
                        //on collide with standing
                        if (walking.onCollideWithObject) walking.onCollideWithObject(o);
                    });
                } else if (o.flying) {
                    game.physics.arcade.collide(walking, o, () => {
                        //on collide with flying
                        //todo[hits];
                        if (walking.onHit) {
                            walking.onHit(o, (item) => {
                                this.objects.add(item);
                            });
                        }

                    });
                }
                if (o.spawnReady) {
                    this.objects.add(o.spawnReady);
                    o.spawnReady = null;
                }
            });
        });

        this.hero.updateInputs(this.cursors);
        let objectOnDirection = this.findObjectOnDirection();

        this.objects.forEachFlying(o => {
            game.physics.arcade.collide(o, this.bgLayer);
            if (o.overlap(this.furnace)) {
                game.sounder.play('flame-2');
                o.setDestroyed();
                this.gameState.onDrop(o);
                if (o.constructor.type === 'jenkins'
                    || o.constructor.type === 'madjenkins'
                    || o.constructor.type === 'friendly_alien') {
                    this.gameState.history.push({ id: 'frn', msg: `made some harsh choices to survive` });
                    this.gameState.addLog('You feel a slight prick of guilt.');
                    this.gameState.badKarma = true;
                }
            }
            this.objects.forEachStanding(o2 => {
                game.physics.arcade.collide(o, o2, () => {
                    o2.onTouchBy(o);
                });
            });
            this.doors.forEach(door => {
                game.physics.arcade.collide(o, door);
            });
            this.gameState.rooms.forEach(room => {
                if (room.breach) {
                    game.physics.arcade.collide(o, room.breach, () => {
                        //this.objects.removeItem(o);
                        room.removeBreach(o);
                    })
                }
            })

        });

        if (this.keys.space.justDown) {
            if (this.hero.holding) {
                //do drop
                this.hero.drop();
            } else if (!this.hero.holding && objectOnDirection) {
                //do hold
                this.gameState.addLog(objectOnDirection.constructor.description);
                this.hero.hold(objectOnDirection);
                game.sounder.play('pick-3');
            }
        }

        if (this.keys.f.justDown) {
            this.hero.takeOffPants();
        }

        // if (this.keys.tab.justDown) {
        //     let code = prompt('Enter event code', '0');
        //     try {
        //         this.narrator.enterEventNum(parseInt(code));
        //     } catch (e) {
        //         console.log('Invalid code', code, e);
        //     }
        // }

        this.activeGroup.sort('y');
    },

    findObjectOnDirection() {
        //objects for now, but maybe aliens also...
        let rect = this.hero.visibilityRectangle;
        let candidate = null;
        this.objects.forEach((o) => {
            if (o.canBeHandled && rect.contains(o.centerX, o.centerY)) {
                if (!candidate || this.hero.distanceTo(o) < this.hero.distanceTo(candidate)) {
                    candidate = o;
                }
            }
        });
        return candidate;
    },


    render() {
        //game.debug.text('FPS: ' + (game.time.fps || '--'), 4, game.canvas.height - 24);
        //game.debug.text('next event:' + this.narrator.nextEventDebug(), 400, game.canvas.height - 24);
        //game.debug.geom(game.shipBounds)
        //game.debug.body(this.hero);
        //game.debug.body(this.furnace);
        //game.debug.geom(this.hero.visibilityRectangle, 'rgba(255,255,0,0.2)');
        //game.debug.body(this.objects.children[2]);
        /*
                for (let c of this.objects.children) {
                    //game.debug.body(c);
                    if (c.walking && c.mover.lastEdge) {
                        game.debug.geom(new Phaser.Line(
                            c.mover.lastEdge.n1.x,
                            c.mover.lastEdge.n1.y,
                            c.mover.lastEdge.n2.x,
                            c.mover.lastEdge.n2.y,
                        ));
                    }
                }*/
    },


};





// WEBPACK FOOTER //
// ./src/states/play.js